import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { FaSearch, } from "react-icons/fa";

function Challan_List({ clientData }) {

  const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
     const[returnBill ,setReturnBill] = useState([]);
           const [showModal, setShowModal] = useState(false);
     const [selectedPurchase, setSelectedPurchase] = useState(null);

    const fetchPurchaseReturn = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-challan-bill/${clientData.id}`);
      // setReturnBill(res.data);
      const sortedData = [...res.data].sort((a, b) => b.cinvoiceNo - a.cinvoiceNo);

    setReturnBill(sortedData);
     
    } catch (error) {
      console.log(error);
    }
  };   

   useEffect(() => {
     fetchPurchaseReturn();
  
    }, []);

    const filteredData = Array.isArray(returnBill)
  ? returnBill
      .filter((itm) =>
        Object.values(itm).some((val) =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
  : [];

  const handleViewItems = (purchase) => {
  setSelectedPurchase(purchase);
  setShowModal(true);
};

const itemList = selectedPurchase?.items
  ? JSON.parse(selectedPurchase.items)
  : [];

  return (
    <div className="party-container">
     <div className="party-header d-flex justify-content-between align-items-center">
    <h2 className="mb-0">All Sale Challan Transaction</h2>
  
    <div className="d-flex align-items-center gap-2">
      <div className="search-box d-flex align-items-center">
        <FaSearch className="me-2" />
        <input
          type="text"
          className="form-control"
          placeholder="Search party name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
  
      <button
        className="btn btn-primary"
        onClick={() => navigate("/home")}
      >
        Back
      </button>
    </div>
  </div>
                           
        <div className="table-responsive ">
      <table className="table  table-hover text-center">
        <thead >
          <tr >
            <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Challan No</th>
            <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Challan Date</th>
            <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Customer Name</th>
            <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Customer Number</th>
            <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Inv No.</th>
            <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Inv Date</th>
    
            <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }} >View</th>
          </tr>
        </thead>
    
        <tbody>
          {filteredData.length === 0 ? (
            <tr>
              <td colSpan="8" className="text-center text-muted">
                No Transaction Found
              </td>
            </tr>
          ) : (
            filteredData.map((item, index) => (
              <tr key={item.id}>
                <td>{item.cinvoiceNo}</td>
                <td>{item.challan_date}</td>
                <td>{item.name}</td>
                <td>{item.mobile}</td>
                <td>{item.invoiceNo}</td>
                <td> {item.date }</td>
            <td> 
    
               <button className="btn-credit p-1" onClick={() => handleViewItems(item)}>
              View Item
              </button>
            </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {showModal && (
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered">
    
          <div className="modal-content">
    
            {/* Header */}
            <div className="modal-header">
              <h5 className="modal-title">Items</h5>
    
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowModal(false)}
              />
            </div>
    
            {/* Body */}
            <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
              <table className="table table-sm table-bordered">
                <thead className="table-info">
                  <tr >
                    <th style={{ backgroundColor: "var(--primary)",color: "#fff" }}>SN</th>
                    <th style={{ backgroundColor: "var(--primary)",color: "#fff" }}>Item Name</th>
                    <th style={{ backgroundColor: "var(--primary)" ,color: "#fff"}}>Qty</th>
             
                    <th style={{ backgroundColor: "var(--primary)",color: "#fff" }}>Sale Price</th>
                    <th style={{ backgroundColor: "var(--primary)",color: "#fff" }}>Discount</th>
                    <th style={{ backgroundColor: "var(--primary)" ,color: "#fff"}}>Total</th>
                  </tr>
                </thead>
    
                <tbody>
                  {itemList.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.name || item.itemName}</td>
                      <td>{item.qty || item.quant}</td>
              
                      <td>₹{item.sale_price || 0}</td>
                      <td>{item.discount}</td>
                      <td>₹{item.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
    
            {/* Footer */}
            <div className="modal-footer">
              <button
                className="btn btn-primary"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
            </div>
    
          </div>
        </div>
      </div>
    )}
    </div>
        </div>
  )
}

export default Challan_List
